<template>
<div class="background-loader" :style="[loaderStyle]" v-show="visible">
	<div class="wrapper">
		<div class="rounded-ball" :style="[ballStyle,]"></div>
		<div class="loading-content">{{text}}</div>
	</div>
</div>
</template>

<script>
export default {
  name:'loading',
  data() {
    return {
      loaderStyle: {
        background: this.background,
      },
      ballStyle: {
        borderColor: this.color + ' ' + this.color + ' ' + this.color + ' ' + 'transparent',
        borderWidth: this.borderWidth + 'px',
        borderStyle: 'solid',
        animationDuration: this.duration + 's',
        width: this.size + 'px',
        height: this.size + 'px'
      },
      visible:false,
      text : '',
    }
  },
  props: {
    background: {
      type: String,
      default: 'rgba(0,0,0,.5)'
    },
    color: {
      type: String,
      default: 'red'
    },
    borderWidth: {
      type: Number,
      default: 10
    },
    duration: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 50
    }
  },
  methods:{

  }
}
</script>

<style lang="css" scoped>
.background-loader {
    min-height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}
.wrapper{
	background:rgba(0,0,0,0.7);
	padding:10px;
	border-radius: 5px;
	display: flex;
	max-width:80%;
	min-width:100px;
	flex-direction:column;
	align-items:center;
}
.loading-content{
	padding:8px 0;
	color:#fff;
	text-align:center;
}
@keyframes rotate {
    from {
        transform: rotate(360deg);
    }
    to {}
}
.rounded-ball {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    animation-name: rotate;
    animation-duration: 0.5s;
    animation-fill-mode: backwards;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}
</style>



// WEBPACK FOOTER //
// src/components/loading/loading.vue